import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import React from 'react'
import { Link } from 'react-router-dom';
import { Api } from '../../redux/api/BaseApi';
import { TicketSavedDialogProps } from '../../types/Props/TicketSavedProps'

const TicketSavedDialog = (props: TicketSavedDialogProps) => {
  const { data: userProfile } = Api.useGetUserProfileQuery();


  return (
    <div>
      <Dialog className='ticket-success' title={<div className=''>{props.title}</div>} onClose={props.toggleDialog} >
        <p
          style={{
            margin: "25px",
            textAlign: "center",
          }}
        >
          {userProfile.Phrases.CallPhrase + (props.ticketIds.length > 1 ? 's' : '')}
          {props.ticketIds.map(tid => {
            return (
              <Link to={`/ticket/${tid}`} target='_blank'> {tid}{props.ticketIds.length > 1 ? ',' : ''}</Link>
            )
          })}
          {(props.ticketIds.length > 1 ? ' were' : ' was') + ' logged successfully.'}
        </p>
        <DialogActionsBar>
          <button
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
            onClick={props.toggleDialog}
          >
            OK
          </button>
          <button
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
            onClick={props.viewDetails}
            disabled={props.ticketIds.length > 1}
          >
            View Details
          </button>
        </DialogActionsBar>
      </Dialog>
    </div>
  )
}

export default TicketSavedDialog